import { useTypedSetCache } from '../helpers/useTypedSetCache';

export const usePostUpdateCache = (post_id: number) =>
  useTypedSetCache('get', `/communication/press/{post_id}/`, {
    params: {
      path: {
        post_id
      }
    }
  });
